import React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { addNotification } from 'actions/notifications/notifications';

class UniqueGazetters extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            gazetters: this.createSameGazetters(props.gazetters),
        };
    }

    makeUniqueGazetters(gazetters) {
        return _.uniqWith(gazetters, (a, b) => a.gazetteerName.toLowerCase() === b.gazetteerName.toLowerCase());
    }

    createSameGazetters(gazetters) {
        const uniqueGazetters = this.makeUniqueGazetters(gazetters);

        return uniqueGazetters.sort((a, b) => {
            if (a.gazetteerName < b.gazetteerName) {
                return -1;
            } else if (a.gazetteerName > b.gazetteerName) {
                return 1;
            }

            return 0;
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            gazetters: this.createSameGazetters(nextProps.gazetters),
        });
    }

    render() {
        const { gazetters } = this.state;

        return (
            <div className='sidebar-table'>
                <div className='paper-block'>
                    <span className='name-block absolute small-name'>Total found unique gazetters: {gazetters.length}</span>
                    {
                        gazetters.map((gazetter, i) => (<div style={{ padding: '5px', background: gazetter.color }} key={i}>
                            {gazetter.gazetteerName}
                        </div>))
                    }
                </div>
            </div>
        );
    }
}

export default connect(
    (state, { gazetters }) => ({
        gazetters,
    }),
    dispatch => ({
        ...bindActionCreators({
            addNotification,
        }, dispatch),
        dispatch, 
    }),
)(UniqueGazetters);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Sidebar/UniqueGazetters.jsx